/* Since this is a thin wrapper around a set of icons, 
we want to allow prop spreading */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import TrackerSolid from '#/shared/components/GeneratedIcons/trimet/Tracker';
import PlannerSolid from '#/shared/components/GeneratedIcons/trimet/Planner';
import BusSolid from '#/shared/components/GeneratedIcons/trimet/Bus';
import AlertSolid from '#/shared/components/GeneratedIcons/trimet/AlertSolid';

function TripToolIcon(props) {
  const { type } = props;
  return {
    tracker: <TrackerSolid {...props} />,
    planner: <PlannerSolid {...props} />,
    routes: <BusSolid {...props} />,
    alerts: <AlertSolid {...props} />,
  }[type.toLowerCase()];
}

TripToolIcon.propTypes = {
  type: PropTypes.string.isRequired,
};

export default TripToolIcon;
